import * as React from "react";
import { Trans, useTranslation } from "react-i18next";

export interface UnassignedAssigneeActivityProps {
  activity: any;
}

export function UnassignedAssigneeActivity({
  activity,
}: UnassignedAssigneeActivityProps): JSX.Element {
  const { toObject, actor, insertedAt } = activity;
  const { t } = useTranslation("ai.workflows.activities");

  return (
    <div>
      <Trans i18nKey="UnassignedAssigneeActivity" t={t}>
        {{ actorName: actor.name }} added {{ objectName: toObject.name }}{" "}
        {{ insertedAt }}
      </Trans>
    </div>
  );
}
